import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../../../utils/Loader";
import { toast } from "react-toastify";

const LoanView = ({ close, idCrypt }) => {
    const [loading, setLoading] = useState(true);
    const [loan, setLoan] = useState({});
    const [installments, setInstallments] = useState([]);
    const navigate = useNavigate();
    const [isPayModalOpen, setIsPayModalOpen] = useState(false);
    const [selectedInstallment, setSelectedInstallment] = useState(null);
    const [payDetails, setPayDetails] = useState({
        amount: "",
        payment_date: "",
        remarks: "",
    })
    const [validation, setvalidation] = useState([])

    const openPayModal = (installment) => {

        setPayDetails({
            amount: installment?.total_due
        })
       
        setSelectedInstallment(installment);
        setIsPayModalOpen(true);
    };

    const closePayModal = () => {
        setIsPayModalOpen(false);
        setSelectedInstallment(null);
        fetchData()
    };


    const handlePaySubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`public/api/loans/${idCrypt}/pay`, payDetails, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
           
            toast.success(response?.data?.message)
            closePayModal()
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }
            setvalidation(error.response.data);
        }
    }

    const fetchData = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const res = await axios.get(`public/api/loans/${idCrypt}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });

            setLoan(res.data);
            setInstallments(res.data.installments || []);
        } catch (error) {
            if (error.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return (
            <Loader />
        )
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setPayDetails((prevData) => ({
            ...prevData,
            [name]: value,
        }))

    }

    return (
        <div className="p-6 max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-bold">Loan Details</h1>
                <button
                    onClick={close}
                    className="text-gray-500 hover:text-gray-800"
                >
                    ✕
                </button>
            </div>

            <div className="border-b my-4" />

            {/* Loan Summary */}
            <h2 className="font-semibold mb-3">Loan Summary</h2>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <Info label="Loan Amount" value={`₹ ${loan.loan_amount}`} />
                <Info label="Interest Rate" value={`${loan.interest_rate}%`} />
                <Info label="Interest Type" value={loan.interest_type.replace('_', ' ')}  />
                <Info label="Start Date" value={loan.loan_start_date} />
                {/* <Info label="Tenure" value={`${loan.loan_terms_months} Months`} /> */}
                <Info label="Calculation Day" value={loan.calculation_day} />
                <Info
                    label="Outstanding"
                    value={`₹ ${loan.outstanding_principal}`}
                />
                <Info label="Status" value={loan.status} />
            </div>

            {/* Installments */}
            <div className="mt-8">
                <h2 className="font-semibold mb-3">Installments</h2>

                <div className="overflow-x-auto border rounded-lg">
                    <table className="min-w-full text-sm">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2 text-left">#</th>
                                <th className="px-4 py-2 text-left">Due Date</th>
                                <th className="px-4 py-2 text-left">Principal</th>
                                <th className="px-4 py-2 text-left">Interest</th>
                                <th className="px-4 py-2 text-left">Total</th>
                                <th className="px-4 py-2 text-left">Paid</th>
                                <th className="px-4 py-2 text-left">Status</th>
                                <th className="px-4 py-2 text-left">Action</th>

                            </tr>
                        </thead>

                        <tbody>
                            {installments.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="7"
                                        className="text-center py-4 text-gray-500"
                                    >
                                        No installments found
                                    </td>
                                </tr>
                            ) : (
                                installments.map((item, index) => (
                                    <tr key={item.id} className="border-t">
                                        <td className="px-4 py-2">{index + 1}</td>
                                        <td className="px-4 py-2">{item.due_date}</td>
                                        <td className="px-4 py-2">
                                            ₹ {item.principal_amount}
                                        </td>
                                        <td className="px-4 py-2">
                                            ₹ {item.interest_amount}
                                        </td>
                                        <td className="px-4 py-2 font-semibold">
                                            ₹ {item.total_due}
                                        </td>
                                        <td className="px-4 py-2">
                                            ₹ {item.paid_amount}
                                        </td>
                                        <td className="px-4 py-2">
                                            <span
                                                className={`px-2 py-1 rounded-full text-xs font-medium
                          ${item.status === "paid"
                                                        ? "bg-green-100 text-green-700"
                                                        : "bg-yellow-100 text-yellow-700"
                                                    }`}
                                            >
                                                {item.status}
                                            </span>
                                        </td>

                                        <td className="px-4 py-2">
                                            <button
                                                onClick={() => openPayModal(item)}
                                                className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                                            >
                                                Pay
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isPayModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">

                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold">
                                Pay Installment
                            </h2>
                            <button
                                onClick={closePayModal}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Form */}
                        <form>
                            {/* Amount */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Amount
                                </label>
                                <input
                                    id="amount"
                                    name="amount"
                                    type="number"
                                    placeholder="Enter Loan Amount"
                                    value={payDetails?.amount}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>

                            {/* Payment Date */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Payment Date
                                </label>
                                <input
                                    type="date"
                                    id="payment_date"
                                    name="payment_date"

                                    placeholder="Enter Loan payment Date"
                                    value={payDetails?.payment_date}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>

                            {/* Remarks */}
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Remarks
                                </label>
                                <textarea
                                    rows="3"
                                    id="remarks"
                                    name="remarks"
                                    value={payDetails?.remarks}
                                    onChange={handleChange}
                                    placeholder="Optional notes"
                                    className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                                />
                            </div>

                            {/* Actions */}
                            <div className="flex justify-end gap-3">
                                <button
                                    type="button"
                                    onClick={closePayModal}
                                    className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                                    onClick={handlePaySubmit}
                                >
                                    Confirm Payment
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoanView;

/* Small reusable info box */
const Info = ({ label, value }) => (
    <div className="border rounded-lg p-3 bg-gray-50">
        <p className="text-gray-500 text-xs">{label}</p>
        <p className="font-semibold capitalize">{value || "-"} </p>
    </div>
);
